import React, { useEffect, useMemo, useState } from 'react';

import {
  Box,
  Flex,
  Grid,
  GridItem,
  LinkBox,
  LinkOverlay,
  Spinner,
} from '@chakra-ui/react';

import { FALLBACK_IMAGE } from '../../../constants/ImagePaths';
import { getCollabData } from '../../../data/mock.data.about';
import type { CollaboratorData } from '../../../models/Collaborator';

const MAX_SINGLE_ROW = 7;

const CollabGrid = () => {
  const [collabs, setCollabs] = useState<CollaboratorData[]>([]);
  const [loading, setLoading] = useState(true);

  const getImageUrl = (uri?: string) => {
    if (uri != null && uri !== '') {
      return uri;
    }

    return FALLBACK_IMAGE;
  };

  useEffect(() => {
    getCollabData()
      .then((items: CollaboratorData[]) => {
        setCollabs(items);
      })
      .catch((err) => {
        console.error('Failed to load collaborators:', err);
        setCollabs([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const desktopColumns = useMemo(() => {
    const count = collabs.length;

    if (count <= MAX_SINGLE_ROW) {
      return count || 1;
    }

    return Math.ceil(count / 2);
  }, [collabs.length]);

  if (loading) {
    return (
      <Flex width="100%" justifyContent="center">
        <Spinner />
      </Flex>
    );
  }

  if (collabs.length === 0) {
    return null;
  }

  return (
    <Grid
  templateColumns={{
    base: 'repeat(3, minmax(0, 1fr))',
    md: `repeat(${desktopColumns}, minmax(0, 1fr))`,
  }}
  justifyContent="center"
  columnGap={{ base: '6px', md: '20px', lg: '25px' }}
  rowGap={{ base: '6px', md: '20px', lg: '25px' }}
  fontWeight="bold"
  width={{ base: '100%', md: '80%' }}
  maxWidth="1600px"
  paddingX={{ base: '20px', md: 0 }}
  marginX="auto"
>
  {collabs.map((collab: CollaboratorData, index: number) => (
    <GridItem
      key={`${collab.name}-${index}`}
      width="100%"
      maxWidth={{
        md: '180px',
        lg: '220px',
        xl: '240px',
      }}
      justifySelf="center"
    >
      <LinkBox width="100%">
        <LinkOverlay
          href={collab.link || '#'}
          isExternal={!!collab.link}
        >
          <Box
            width="100%"
            aspectRatio={1}
            backgroundImage={`url(${getImageUrl(collab.image)})`}
            backgroundSize="contain"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
          />
        </LinkOverlay>
      </LinkBox>
    </GridItem>
  ))}
</Grid>
  );
};

export default CollabGrid;